import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

class FilterWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropOpen: false,
    };
  }
  onKeyDown = (event) => {
    // Close dropdown on ESC press
    if (event.keyCode === 27) {
      this.handleOpenFilter();
    }
  }

  handleOpenFilter = () => {
    this.setState(state => ({ ...state, dropOpen: !state.dropOpen }), () => {
      if (this.state.dropOpen) {
        document.addEventListener('keydown', this.onKeyDown);
      } else {
        document.removeEventListener('keydown', this.onKeyDown);
        this.props.onCloseFilter();
      }
    });
  };

  handleRemoveFilter = () => {
    const { id, removeFilter } = this.props;
    removeFilter(id);
  }

  buildFilterName = (changesInFilter, baseName) => {
    if (changesInFilter > 0) {
      return `${baseName}: ${changesInFilter}`;
    }
    return baseName;
  }

  render() {
    const { isUserAdded, changesInFilter } = this.props;
    const name = this.buildFilterName(changesInFilter, this.props.name);

    return (
      <div className={classNames('filter-button', { configured: changesInFilter })}>
        <div className={classNames('button-container', { active: this.state.dropOpen })}>
          <div onClick={this.handleOpenFilter} className="button">
            <span>{ name }</span>
            <div className="dropdown-arrow" />
            { isUserAdded && <div onClick={this.handleRemoveFilter} className="delete-filter-option" /> }
          </div>
        </div>
        {
          this.state.dropOpen &&
          <div>
            <div onClick={this.handleOpenFilter} className="modal-dropdown" />
            <div className={classNames('filter-body', { open: this.state.dropOpen })}>
              { this.props.children }
            </div>
          </div>
        }
      </div>
    );
  }
}

FilterWrapper.propTypes = {
  changesInFilter: PropTypes.number,
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isUserAdded: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onCloseFilter: PropTypes.func,
  removeFilter: PropTypes.func,
};

FilterWrapper.defaultProps = {
  changesInFilter: 0,
  isUserAdded: false,
  onCloseFilter: () => {},
  removeFilter: () => {},
};

export default FilterWrapper;
